import React from 'react';

import { useWarehouseContext } from 'providers/WarehouseProvider';

import Table from 'components/common/Table';

import { inventoryApi } from 'api';

import {
  INVENTORY_HISTORY_LIST_COLUMNS,
  INVENTORY_HISTORY_FILTER_OPTIONS,
} from 'constants/inventory';

const InventoryHistory = () => {
  const { selectedWarehouse } = useWarehouseContext();
  const initialFilter = {
    warehouse: selectedWarehouse?.id,
    inventory_history_method: ['increase', 'force_update', 'decrease'],
  };

  return (
    <Table
      title="Inventory History"
      apiService={inventoryApi}
      sortable={true}
      columns={INVENTORY_HISTORY_LIST_COLUMNS}
      filterOptions={INVENTORY_HISTORY_FILTER_OPTIONS}
      initialPageSize={50}
      initialFilter={initialFilter}
      fetchConfig={{
        method: 'getInventoryHistoryList',
      }}
    />
  );
};

export default InventoryHistory;
